module.exports = __webpack_public_path__ + "static/media/over_capacity_normal.381ba1e1.svg";